import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import image1 from "../1.png";
import image2 from "../2.png";
import image3 from "../3.png";
import image4 from "../4.png";

const Final = () => {
  const navigate = useNavigate();
  const firstpage = () => {
    navigate("/page7", {
      state: { hexkey, hexuserInput, KeyValue, userInput },
    });
  };
  const second = () => {
    navigate("/complete", {
      state: {
        hexkey,
        hexuserInput,
        KeyValue,
        userInput,
      },
    });
  };

  const check1 = () => {
    var x = document.getElementById("fname").value;
    if (
      x === "F" ||
      x === "f" ||
      x === "Function f" ||
      x === "function f" ||
      x === "Function F" ||
      x === "function F"
    ) {
      document.getElementById("a").style.display = "none";
      document.getElementById("b").style.display = "block";
    } else {
      alert("Incorrect answer");
    }
  };

  const check2 = () => {
    var y = document.getElementById("sec").value;
    if (
      y === "G" ||
      y === "g" ||
      y === "Function g" ||
      y === "function g" ||
      y === "Function G" ||
      y === "function G"
    ) {
      document.getElementById("b").style.display = "none";
      document.getElementById("c").style.display = "block";
    } else {
      alert("Incorrect answer");
      alert(y);
    }
  };

  const check3 = () => {
    var x = document.getElementById("third").value;
    if (
      x == "ROL" ||
      x == "rol" ||
      x == "Rotate left" ||
      x == "rotate left" ||
      x == "Rotate Left" ||
      x == "rotate Left"
    ) {
      document.getElementById("c").style.display = "none";
      document.getElementById("next").style.display = "block";
        document.getElementById("next2").style.display = "block";
    } else {
      alert("Incorrect answer");
    }
  };

  const location = useLocation();
  const userInput = location.state.userInput;
  const KeyValue = location.state.KeyValue;
  const hexuserInput = location.state.hexuserInput;
  const hexkey = location.state.hexkey;

  return (
    <>
      <div>
        <div className="mx-auto align-middle justify-cente text-center">
          <h1 className=" font-semibold text-3xl pb-5">Fill the blanks</h1>
          <p>
            Fill in the blanks highlighted in the images from what is learnt so
            far.
          </p>
        </div>
        <div className="mx-auto align-middle justify-center text-center" id="a">
          <img
            src={image1}
            alt="1"
            className="pt-10 mx-auto align-middle justify-center text-center max-h-96"
          />

          <input
            type="text"
            id="fname"
            name="fname"
            placeholder="Name the function"
            className=" align-middle justify-center text-center max-h-96 border-solid border-2 border-black rounded-md"
          />
          <br />
          <button
            type="submit"
            className="mx-auto mt-5 align-middle justify-center text-center max-h-96  rounded-md bg-blue-500 text-white px-4 py-2 transition duration-300 ease-in-out hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-50"
            onClick={check1}
          >
            Submit
          </button>
        </div>

        <div
          className="mx-auto align-middle justify-cente text-center hidden"
          id="b"
        >
          <img
            src={image2}
            alt="2"
            className="pt-10 mx-auto align-middle justify-cente text-center max-h-96"
          />

          <input
            type="text"
            id="sec"
            name="sec"
            placeholder="Name the function"
            className=" align-middle justify-center text-center max-h-96 border-solid border-2 border-black rounded-md"
          />
          <br />
          <button
            type="submit"
            className="mx-auto mt-5 align-middle justify-center text-center max-h-96  rounded-md bg-blue-500 text-white px-4 py-2 transition duration-300 ease-in-out hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-50"
            onClick={check2}
          >
            Submit
          </button>
        </div>

        <div
          className="mx-auto align-middle justify-cente text-center hidden"
          id="c"
        >
          <img
            src={image3}
            alt="3"
            className="pt-10 mx-auto align-middle justify-cente text-center max-h-96"
          />

          <input
            type="text"
            id="third"
            name="c"
            placeholder="Name the function"
            className=" align-middle justify-center text-center max-h-96 border-solid border-2 border-black rounded-md"
          />
          <br />
          <button
            type="submit"
            className="mx-auto mt-5 align-middle justify-center text-center max-h-96  rounded-md bg-blue-500 text-white px-4 py-2 transition duration-300 ease-in-out hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-50"
            onClick={check3}
          >
            Submit
          </button>
        </div>

        <div
          className="mx-auto align-middle justify-cente text-center hidden"
          id="next"
        >
          <img
            src={image4}
            alt="1"
            className="pt-10 mx-auto align-middle justify-cente text-center max-h-96"
          />
          <h1>You have completed the experiment</h1>
        </div>
      </div>
      <div class="button-holder">
        <div class="prev-button" onClick={firstpage}>
          PREVIOUS
        </div>
        <div className="hidden" id="next2">
          <div class="next-button" onClick={second}>
            NEXT
          </div>
        </div>
      </div>
    </>
  );
};

export default Final;
